import React from 'react';
import useStyles from './styles'
import {Link} from 'react-router-dom'

function BoardCard({title, description, id}) {
  const c = useStyles();

  return (
    <Link to={'/scrum-board/'+(id||"")} className={c.card}>
      <span title={title}>{title}</span>
      <div title={description}>
        {description}
      </div>
    </Link>
  );
}

export default BoardCard;